interface SegmentOption<T> {
  value: T
  label: string
}

interface PickSegmentProps<T> {
  options: SegmentOption<T>[]
  value: T
  onChange: (value: T) => void
  className?: string
}

function PickSegment<T>({ options, value, onChange, className = '' }: PickSegmentProps<T>) {
  return (
    <div className={`flex gap-1 rounded-xl bg-ink/25 p-1 ${className}`}>
      {options.map((opt, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`min-h-[calc(44px*var(--scale))] flex-1 rounded-[9px] text-[0.85em] font-semibold ${
            opt.value === value ? 'bg-cream text-ink' : 'text-text-2'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}

export default PickSegment
